import React from "react";
import { cn } from "../../lib/cn";

export interface IconButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "onClick"> {
  icon: React.ReactNode;
  ariaLabel: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  className?: string;
}

/** claudesign 42×42 square icon button (overflow/compact actions).
 *  Forwards its ref and spreads unknown props onto the underlying <button>
 *  so it composes correctly as a Radix `asChild` trigger. */
export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ icon, ariaLabel, onClick, disabled, className, ...rest }, ref) => (
    <button
      type="button"
      ref={ref}
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "inline-grid place-items-center w-[42px] h-[42px] rounded-sm cursor-pointer",
        "border border-border-soft bg-surface text-muted shadow-edge-hi",
        "transition-[background,color,border-color] duration-150",
        "hover:bg-surface-hi hover:text-white hover:border-border",
        "disabled:cursor-default disabled:opacity-55",
        "[&_svg]:w-[18px] [&_svg]:h-[18px]",
        className,
      )}
      {...rest}
    >
      {icon}
    </button>
  ),
);

IconButton.displayName = "IconButton";

export default IconButton;
